module.exports = __webpack_public_path__ + "productivity3.webp?026400f658cac7b5cb29c40663dcf450";